import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import {
  isConversationalWorkflowResultObject,
  isOperatorSafeConversationalWorkflowResultObject,
} from "../conversationalWorkflow";

export const isConversationalWorkflowsResult = objectOf({
  hits: number,
  results: arrayOf(isConversationalWorkflowResultObject),
});

export const isOperatorSafeConversationalWorkflowsResult = objectOf({
  hits: number,
  results: arrayOf(isOperatorSafeConversationalWorkflowResultObject),
});

export const isGetConversationalWorkflowsResult = anyOf(
  isConversationalWorkflowsResult,
  isOperatorSafeConversationalWorkflowsResult
);
